<template>
  <v-hover>
    <v-img slot-scope="{ hover }" contain class="mb-0 test-wall" :src="wall.img">
      <div class="default-wall-container">
        <img
          v-if="artwork.media && artwork.media.length"
          draggable="false"
          sizes="(max-width: 959px) 100vw, 824px"
          :srcset="artwork.media[0].srcset"
          :src="artwork.media[0].url"
          :style="{'background-color': artwork.media[0].color }"
          @click="$router.push({path: artwork.path})"
          @contextmenu="(e) => e.preventDefault()"
        />
      </div>

      <!-- Arrow buttons -->
      <ImageCarouselsButtons
        v-if="hover || showArrrowButtons"
        :artwork="artwork"
        @prev="$router.push({path: artwork.path})"
        @next="$router.push({path: artwork.path})"
      />
    </v-img>
  </v-hover>
</template>

<script>
import { defaultWall } from "@/config";
import ImageCarouselsButtons from "../ImageCarouselsButtons";

export default {
  props: ["artwork"],

  components: { ImageCarouselsButtons },

  data() {
    return {
      showArrrowButtons: false,
    };
  },

  computed: {
    wall: () => defaultWall,
  },

  created() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.showArrrowButtons = true;
    }
  },
};
</script>

<style
  lang="scss"
  scoped
>
.test-wall {
  user-select: none;
  position: relative;

  .default-wall-container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    width: 100%;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px;

    img {
      width: auto;
      max-height: 100%;
      max-width: 100%;
      box-shadow: 0 0 5px 0 #000;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
</style>
